import React from "react";
import { Box, Button, Drawer } from "@mui/material";
import Useredit from "../assets/images/sidebar-icon/user-edit.svg";
import UsereditActive from "../assets/images/sidebar-icon/user-edit-active.svg";
import UserSubscription from "../assets/images/sidebar-icon/user-subscription.svg";
import UserSubscriptionActive from "../assets/images/sidebar-icon/user-subscription-active.svg";
import Swap from "../assets/images/sidebar-icon/Swap.svg";
import SwapActive from "../assets/images/sidebar-icon/Swap-active.svg";
import Lock from "../assets/images/sidebar-icon/Lock.svg";
import LockActive from "../assets/images/sidebar-icon/Lock-active.svg";
import Helpicon from "../assets/images/sidebar-icon/message-question.svg";
import HelpiconActive from "../assets/images/sidebar-icon/message-question-active.svg";
import { NavItems } from "./MenteeHeader";
import { Menu } from "@mui/icons-material";

const sidebarMenuItems = [
  {
    icon: Useredit,
    activeIcon: UsereditActive,
    name: "Edit Profile",
    url: "/profile/edit-profile",
  },
  {
    icon: UserSubscription,
    activeIcon: UserSubscriptionActive,
    name: "Payment Details",
    url: "/profile/payment-details",
  },
  {
    icon: Swap,
    activeIcon: SwapActive,
    name: "Transactions",
    url: "/profile/transactions",
  },
  {
    icon: Lock,
    activeIcon: LockActive,
    name: "Change Password",
    url: "/profile/change-password",
  },
  {
    icon: Helpicon,
    activeIcon: HelpiconActive,
    name: "Help & Support",
    url: "/profile/help-support",
  },
];

const DashboardHeaderMobile = () => {
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const role = localStorage.getItem("role");
  const DrawerList = (
    <Box
      sx={{
        width: {
          xs: "200px",
          sm: 250,
        },
      }}
      role="presentation"
      onClick={toggleDrawer(false)}
    >
      <Box
        sx={{
          padding: "14px",
          marginTop: "20px",
        }}
      >
        {role && NavItems(role)}
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        textAlign: "left",
        display: { xs: "block", sm: "block", md: "none" },
      }}
    >
      <Button
        sx={{ justifyContent: "flex-end", minWidth: "auto" }}
        onClick={toggleDrawer(true)}
      >
        <Menu sx={{ width: "34px", height: "34px" }} />
      </Button>
      <Drawer
        sx={{
          "& .MuiPaper-root.MuiPaper-elevation": {
            borderRadius: "0 18px 18px 0",
          },
        }}
        open={open}
        onClose={toggleDrawer(false)}
      >
        {DrawerList}
      </Drawer>
    </Box>
  );
};

export default DashboardHeaderMobile;
